query TravelAuthorizationSearchHints(
  $searchRequest: SearchRequestInput!
  $isLinkSearch: Boolean
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $isSearchAllData: Boolean
  $filterMultiStatusTypes: [Int]
) {
  travelAuthorizationSearchHints(
    searchRequest: $searchRequest
    isLinkSearch: $isLinkSearch
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    isSearchAllData: $isSearchAllData
    filterMultiStatusTypes: $filterMultiStatusTypes
  ) {
    nodes {
      id
      caption
      linkType
      resultsCount
    }
  }
}
